import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';
import { Grid, Row, Col, Button, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';

const BORDER_COLOURS = {
    warning: '#eea236',
    primary: '#2e6da4',
    danger: '#d43f3a',
    success: '#4cae4c',
    default: '#ccc',
    info: '#1b6d85',
};

const DEFAULT_OTHER_CONFIG = { allowURLChange: false, iFrameURL: '' };

export default function IFrame({ eventModuleRow, updateEventModuleRow }) {
    const hasValidConfig = eventModuleRow.other_config &&
        Object.entries(eventModuleRow.other_config).length === 2;

    const [iFrameName, setIFrameName] = useState(eventModuleRow.name);
    const [iFrameURL, setIFrameURL] = useState(hasValidConfig ? eventModuleRow.other_config.iFrameURL : '');
    const [bStyle, setBStyle] = useState(eventModuleRow.colour ?? 'default');
    const [other_config, setOtherConfig] = useState(hasValidConfig ? eventModuleRow.other_config : DEFAULT_OTHER_CONFIG);
    const [invalidURL, setInvalidURL] = useState(null);
    const [testIframe, setTestIframe] = useState(false);
    const [testURL, setTestURL] = useState('');

    useEffect(() => {
        setIFrameName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour ?? 'default');
        if (eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 2) {
            setOtherConfig(eventModuleRow.other_config);
            setIFrameURL(eventModuleRow.other_config.iFrameURL);
        }
    }, [eventModuleRow]);

    function notify(overrides) {
        updateEventModuleRow({
            name: iFrameName,
            colour: bStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            ...overrides,
        });
    }

    function handleChange(e) {
        if (e.target.name === 'iFrameName') {
            const newName = e.target.value;
            setIFrameName(newName);
            notify({ name: newName });
        } else if (e.target.name === 'iFrameURL') {
            let errorStatus = null;
            if (e.target.value.indexOf('.') !== -1) {
                if (e.target.value.length < 9) {
                    errorStatus = 'error';
                } else if (e.target.value.substring(0, 7) !== 'http://' && e.target.value.substring(0, 8) !== 'https://') {
                    errorStatus = 'error';
                }
            }
            setInvalidURL(errorStatus);
            setIFrameURL(e.target.value);
        } else if (e.target.name === 'allowURLChange') {
            const newConfig = { ...other_config, allowURLChange: !other_config.allowURLChange };
            setOtherConfig(newConfig);
            notify({ other_config: newConfig });
        }
    }

    function handleTestURL() {
        const newConfig = { ...other_config, iFrameURL };
        setOtherConfig(newConfig);
        notify({ other_config: newConfig });
        setTestURL(iFrameURL);
        setTestIframe(true);
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        notify({ colour: newStyle });
    }

    return (
        <Grid>
            <Row>
                <Col xs={6} md={5}>
                    <SelectColourButton
                        title="Select Colour"
                        groupingSequence={eventModuleRow.event_grouping_seq}
                        selectedColour={colourSelected}
                        bStyle={bStyle} />
                </Col>
            </Row>
            <Row style={{ marginTop: '8px' }}>
                <Col xs={6} md={5}>
                    <FormControl type="text"
                        placeholder="Enter iFrame Name"
                        name="iFrameName"
                        autoFocus={true}
                        value={iFrameName}
                        onChange={handleChange}
                        style={{ width: '100%' }} />
                </Col>
            </Row>
            <Row style={{ marginTop: '8px' }}>
                <Col xs={6} md={5}>
                    <form>
                        <FormGroup controlId="iFrameURLGroup" validationState={invalidURL} style={{ width: '100%' }}>
                            <FormControl type="text"
                                placeholder="URL"
                                name="iFrameURL"
                                autoFocus={false}
                                value={iFrameURL}
                                onChange={handleChange}
                                style={{ width: '100%' }} />
                            <HelpBlock>{invalidURL === null ? '' : 'URL must start with http:// or https://'}</HelpBlock>
                            <FormControl.Feedback />
                        </FormGroup>
                    </form>
                </Col>
                <Col xs={2} md={5}>
                    <Button name="Test"
                        bsStyle="success"
                        disabled={invalidURL !== null || iFrameURL.length < 9}
                        onClick={handleTestURL}>
                        Test
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={6} md={5}>
                    <input name="allowURLChange"
                        style={{ marginRight: '10px' }}
                        checked={other_config.allowURLChange}
                        onChange={handleChange}
                        type="checkbox" value="" />
                    Allow URL to be changed
                </Col>
            </Row>
            {testIframe && (
                <Row key="iFrameModal" style={{ height: '200px', display: 'block' }}>
                    <Col xs={7} md={5} style={{ height: '100%' }}>
                        <iframe src={testURL}
                            sandbox="allow-forms allow-top-navigation-by-user-activation allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
                            style={{
                                width: '100%', height: '100%',
                                borderColor: BORDER_COLOURS[bStyle],
                                borderWidth: '4px', borderStyle: 'solid',
                            }}>
                        </iframe>
                    </Col>
                </Row>
            )}
        </Grid>
    );
}
